import React from 'react';
import {Box, HStack, VStack, Text, useToken} from 'native-base';
import {MessageIcon} from './../icons';

interface Props {
  title: string;
  summary: string;
  color: string;
  unread: boolean;
}

const NotificationsItem = (props: Props) => {
  const {title, summary, color, unread} = props;
  const [colorBlue400, colorGray300] = useToken('colors', [
    'blue.400',
    'gray.300',
  ]);
  return (
    <Box marginBottom={5}>
      <HStack>
        <MessageIcon
          width="50"
          height="100%"
          color={unread ? colorBlue400 : colorGray300}
        />
        <VStack paddingX={3}>
          <Text color={color} fontWeight="extrabold" fontSize="lg">
            {title}
          </Text>
          <Text color={color} fontSize="sm" paddingRight={10}>
            {summary}
          </Text>
        </VStack>
      </HStack>
    </Box>
  );
};

export default NotificationsItem;
